export const FormSamplesSubmitButtonOnlyPageInfo = () => {
    return (
        <>
            Submit button only, for example a login screen.
        </>
    )
}
